<template>
  <table class="table table-bordered">
    <thead class="thead-dark">
      <tr>
        <th class="text-center">#</th>
        <th>Name</th>
        <th class="text-center">Bearbeiten</th>
        <th class="text-center">Löschen</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="4">
          <router-link :to="{name: 'course-room-create'}">+ Kursraum erstellen</router-link>
        </td>
      </tr>
      <tr v-for="(courseRoom, index) in courseRooms" :key="courseRoom.id">
        <th class="text-center">{{ index + 1 }}</th>
        <td>{{ courseRoom.name }}</td>
        <td class="text-center">
          <router-link
            :to="{name: 'course-room-details', params: {id: studioId, courseRoomId: courseRoom.id}}"
          >
            <i class="fa fa-edit text-dark"></i>
          </router-link>
        </td>
        <td class="text-center" @click="remove(courseRoom.id)">
          <i class="fa fa-trash cursor-pointer"></i>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { firestore } from '../firebase';

export default {
  data() {
    return {
      studioId: this.$route.params.id,
      courseRooms: []
    };
  },
  async created() {
    const courseRoomsSnapshot = await firestore
      .collection('studios')
      .doc(this.studioId)
      .collection('courseRooms')
      .get();

    this.courseRooms = courseRoomsSnapshot.docs.map(snapshot => {
      return {
        id: snapshot.id,
        ...snapshot.data()
      };
    });
  },
  methods: {
    async remove(id) {
      if (
        confirm('Bist du sicher, dass du diesen Kursraum löschen möchtest?')
      ) {
        await firestore
          .collection('studios')
          .doc(this.studioId)
          .collection('courseRooms')
          .doc(id)
          .delete();

        this.courseRooms = this.courseRooms.filter(
          courseRoom => courseRoom.id !== id
        );
      }
    }
  }
};
</script>

<style>
</style>